import { Controller } from "@hotwired/stimulus"

// Barra de búsqueda del header: la lupa despliega un panel bajo el header con
// el input y las sugerencias en vivo. Mismo esquema que mobile-menu (con el
// que convive en el <header>): cada botón cierra al otro panel primero.
export default class extends Controller {
  static targets = ["panel", "overlay", "input", "button"]

  connect() {
    this.closeSilently = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeSilently)
    // Sin esto, el snapshot de Turbo guardaría el panel abierto y el botón
    // "atrás" lo haría reaparecer.
    document.addEventListener("turbo:before-cache", this.closeSilently)

    // Clic en cualquier parte fuera del panel: cerrar. El overlay ya cubre la
    // página, pero la fila del header (logo, espacios) queda sobre él y sin
    // esto un clic ahí dejaba el panel abierto.
    this.closeOnOutsideClick = (event) => {
      if (!this.#isOpen()) return
      if (this.panelTarget.contains(event.target)) return
      if (this.buttonTarget.contains(event.target)) return // toggle decide

      this.close()
    }
    document.addEventListener("click", this.closeOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeSilently)
    document.removeEventListener("turbo:before-cache", this.closeSilently)
    document.removeEventListener("click", this.closeOnOutsideClick)
    this.#unlockScroll()
  }

  // Enter: a la página completa de resultados. Se visita /buscador sin frame
  // y el servidor redirige a /recursos con el término (una sola fuente de
  // verdad para esa URL).
  goToResults(event) {
    event.preventDefault()
    const url = new URL(this.inputTarget.form.action, window.location.origin)
    const termino = this.inputTarget.value.trim()
    if (termino) url.searchParams.set("termino", termino)

    window.Turbo.visit(url.toString())
  }

  toggle() {
    this.#isOpen() ? this.close() : this.open()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.body.classList.add("overflow-hidden")
    // El autofocus HTML solo aplica en la carga inicial; aquí se enfoca a mano
    // y se selecciona lo escrito para poder reemplazarlo de una.
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.overlayTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.#unlockScroll()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  #isOpen() {
    return !this.panelTarget.classList.contains("hidden")
  }

  #unlockScroll() {
    document.body.classList.remove("overflow-hidden")
  }
}
